import { Component } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { FieldArrayType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';

import { createFormlyRuleset, createFormlyRule, createRule } from '../utils';
import { NgClass } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-ruleset-rules-type',
    templateUrl: './ruleset-rules-type.component.html',
    styleUrls: ['./ruleset-rules-type.component.scss'],
    imports: [NgClass, ExtendedModule, MatIconButton, MatTooltip, MatIcon, FormlyModule]
})
export class RulesetRulesTypeComponent extends FieldArrayType {
  prePopulate(field: FormlyFieldConfig) {
    if (!field.parent) {
      return;
    }

    field.fieldGroup = field.fieldGroup || [];
    if (field.fieldGroup.length > field.model.length) {
      for (let i = field.fieldGroup.length; i >= field.model.length; --i) {
        (field.formControl as UntypedFormArray).removeAt(i);
        field.fieldGroup.splice(i, 1);
      }
    }

    for (let i = field.fieldGroup.length; i < field.model.length; i++) {
      // Add correct field based on model signature
      if (field.model[i].operator || Object.prototype.hasOwnProperty.call(field.model[i], 'field')) {
        const { ruleOptions } = field.options.formState;
        field.fieldGroup.push({
          key: `${i}`,
          fieldGroup: [...createFormlyRule(ruleOptions)],
        });
      } else {
        field.fieldGroup.push({
          key: `${i}`,
          fieldGroup: [...createFormlyRuleset()],
        });
      }
    }
  }

  isRule(i: number): boolean {
    const node = this.field.model?.[i];
    return !!node && (!!node.operator || Object.prototype.hasOwnProperty.call(node, 'field'));
  }

  override remove(i: number): void {
    super.remove(i);
    if ((this.options?.formState as any)?.workChanged && this.model.length === 0) super.add(0, createRule());
    (this.options?.formState as any)?.workChanged?.();
  }
}
